import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface CardPlanProgressProps {
  actualOrdersAmount: number;
  plannedOrdersAmount: number;
}

export const CardPlanProgress: React.FC<CardPlanProgressProps> = ({
  actualOrdersAmount = 0,
  plannedOrdersAmount = 0,
}) => {
  const remaining = plannedOrdersAmount - actualOrdersAmount;
  const progress = Math.min((actualOrdersAmount / plannedOrdersAmount) * 100, 100);

  if (plannedOrdersAmount === 0)
    return (
      <Card className="p-4">
        <CardHeader>
          <CardTitle>Нет плана!!!</CardTitle>
        </CardHeader>
      </Card>
    );

  return (
    <Card className="p-4 flex flex-col justify-between min-h-0 ">
      <CardHeader>
        <CardTitle>{remaining <= 0 ? "План выполнен!" : "Осталось до выполнения плана"}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-5 ">
        {remaining <= 0 ? (
          <div className="text-2xl font-semibold">
            <p>План по заказам: {plannedOrdersAmount} шт.</p>
            <p>Всего заказов: {actualOrdersAmount} шт.</p>
          </div>
        ) : (
          <>
            <div className="text-2xl font-semibold">Осталось {remaining} шт.</div>
            <Progress value={progress} />
          </>
        )}
      </CardContent>
    </Card>
  );
};
